module.exports = __webpack_public_path__ + "img/face-thinning.11b915f7.svg";